import { jsx as s, jsxs as k } from "react/jsx-runtime";
import { c as u } from "./clsx-OuTLNxxd.js";
import { I as L } from "./icon-CCupal-M.js";
import "./components/elements/icon/iconsList.js";
const N = "_link_gmx3v_29", i = {
  link: N,
  "is-small": "_is-small_gmx3v_37",
  "is-primary": "_is-primary_gmx3v_41",
  "is-secondary": "_is-secondary_gmx3v_47",
  "is-inverted": "_is-inverted_gmx3v_53",
  "is-inherited": "_is-inherited_gmx3v_59",
  "is-underlined": "_is-underlined_gmx3v_65",
  "is-disabled": "_is-disabled_gmx3v_78",
  "link-external": "_link-external_gmx3v_87",
  "dialog-overlay-show": "_dialog-overlay-show_gmx3v_1",
  "dialog-content-show": "_dialog-content-show_gmx3v_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_gmx3v_1"
}, f = {
  primary: "is-primary",
  secondary: "is-secondary",
  inverted: "is-inverted",
  inherit: "is-inherited"
};
function O({
  color: x = "primary",
  children: n,
  href: l,
  target: t,
  disabled: e,
  Component: m,
  isSmall: g,
  className: v,
  noUnderline: p = !1,
  external: y,
  ariaLabel: d,
  onClick: r,
  ...a
}) {
  const o = u(
    i.link,
    i[f[x]],
    g && i["is-small"],
    e && i["is-disabled"],
    !p && i["is-underlined"],
    v
  ), _ = /* @__PURE__ */ s("span", { className: o, ...a, children: n });
  if (m)
    return e ? _ : /* @__PURE__ */ s(m, { onClick: r, className: o, href: l, target: t, "aria-label": d, ...a, children: n });
  if (!l)
    return e ? _ : /* @__PURE__ */ s("button", { onClick: r, className: o, ...a, children: n });
  const c = /* @__PURE__ */ s(
    "a",
    {
      onClick: r,
      href: l,
      target: t,
      className: o,
      "aria-label": d,
      ...a,
      children: n
    }
  );
  return e ? _ : y ? /* @__PURE__ */ k("span", { className: i["link-external"], children: [
    c,
    /* @__PURE__ */ s(L, { name: "new-tab", size: "large" })
  ] }) : c;
}
export {
  O as L,
  i as s
};
